// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main {
  padding: 24px;
}
#main .header {
  display: flex;
  padding-left: 20px;
  padding-right: 10px;
}
#main .header .title-dialog {
  flex-basis: 94%;
  word-break: break-word;
}
#main .header .title-dialog h2 {
  font-size: 20px;
}
#main .header .icon-close {
  flex-basis: auto;
  cursor: pointer;
}
#main .header .icon-close button {
  background: white;
  color: red;
}
#main .container-record .container-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  height: 50%;
}
#main .container-record .container-icon mat-icon {
  transform: scale(6);
}
#main .container-record .container-acctions {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
}
#main .container-record .container-acctions button:disabled {
  cursor: not-allowed;
}
#main .container-record .message-recording {
  text-align: center;
  height: 20px;
}
#main .container-record .opacity-0 {
  opacity: 0;
}
#main .container-record .container-audio {
  text-align: center;
  margin-top: 20px;
}
#main .mat-mdc-dialog-content {
  height: 50vh;
}`, "",{"version":3,"sources":["webpack://./src/app/utils/shared/components/audio-recorder/audio-recorder.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;AACR;AACQ;EACI,eAAA;EACA,sBAAA;AACZ;AAAY;EACI,eAAA;AAEhB;AAEQ;EACI,gBAAA;EACA,eAAA;AAAZ;AAEY;EACI,iBAAA;EACA,UAAA;AAAhB;AAOQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AALZ;AAOY;EACI,mBAAA;AALhB;AASQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AAPZ;AASY;EACI,mBAAA;AAPhB;AAWQ;EACI,kBAAA;EACA,YAAA;AATZ;AAYQ;EACI,UAAA;AAVZ;AAaQ;EACI,kBAAA;EACA,gBAAA;AAXZ;AAgBI;EACI,YAAA;AAdR","sourcesContent":["#main {\r\n    padding: 24px;\r\n\r\n    .header {\r\n        display: flex;\r\n        padding-left: 20px;\r\n        padding-right: 10px;\r\n\r\n        .title-dialog {\r\n            flex-basis: 94%;\r\n            word-break: break-word;\r\n            h2 {\r\n                font-size: 20px;\r\n            }\r\n        }\r\n\r\n        .icon-close {\r\n            flex-basis: auto;\r\n            cursor: pointer;\r\n\r\n            button {\r\n                background: white;\r\n                color: red;\r\n            }\r\n        }\r\n    }\r\n\r\n    .container-record {\r\n\r\n        .container-icon {\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            flex-direction: column;\r\n            gap: 30px;\r\n            height: 50%;\r\n\r\n            mat-icon {\r\n                transform: scale(6);\r\n            }\r\n        }\r\n\r\n        .container-acctions {\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            margin-top: 10px;\r\n            gap: 10px;\r\n\r\n            button:disabled {\r\n                cursor: not-allowed;\r\n            }\r\n        }\r\n\r\n        .message-recording {\r\n            text-align: center;\r\n            height: 20px;\r\n        }\r\n\r\n        .opacity-0 {\r\n            opacity: 0;\r\n        }\r\n\r\n        .container-audio {\r\n            text-align: center;\r\n            margin-top: 20px;\r\n        }\r\n\r\n    }\r\n\r\n    .mat-mdc-dialog-content {\r\n        height: 50vh;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
